import {callApi} from './helpers'

export const loadAdAudit = (query) => (dispatch) => {
    return dispatch(callApi({
      viewName: 'ad_audit_list',
      crudMethod: 'listPaging',
      crudParam: query
    }))
}
